<template>
    <cp-select
        :config="routeModules"
        :item-value="itemValue"
        clearable
        v-on="$listeners"
        v-bind="attrs"
        :customSelection="true"
        :customItem="true"
        :returnObject="returnObject"
        :multiple="multiple"
    >
        <template v-slot:selection="{ item }">
            <v-chip
                v-if="multiple"
            >
                {{ `${item.name} (${formatPrice(item.price)})` }}
            </v-chip>

            <span v-else>{{ `${item.name} (${formatPrice(item.price)})` }}</span>
        </template>

        <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action v-if="multiple">
                    <v-icon color="indigo darken-4">
                        {{ attrs.inputValue ? '$checkboxOutline' : '$checkboxBlankOutline' }}
                    </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ `${item.name} (${formatPrice(item.price)})` }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </cp-select>
</template>

<script>
import FormBaseModel from '@cp-models/FormBaseModel'

export default {
    props: {
        routeModules: {
            type: Object,
            required: false,
            default: () => { return {route: 'v2.core.modules'} },
        },
        itemValue: {
            type: String,
            required: false,
            default: 'id',
        },
        returnObject: {
            type: Boolean,
            required: false,
            default: () => { return false },
        },
        multiple: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: () => ({
        model: new FormBaseModel
    }),

    computed: {
        attrs() {
            const { label, name, ...attrs } = this.$attrs;

            return { ...{
                label: label || 'Selecione um Módulo',
                name: name || "select-module"
            }, ...attrs };
        },
    },

    methods: {
        formatPrice(price) {
            return this.model.formatCurrency(price)
        },
    }
}
</script>